module.exports = __webpack_public_path__ + "images/fa-cfa-video-1.webp";